import { Icon } from '@iconify/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ContactInfoWidget() {
  const { t } = useTranslation();

  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        {t('contact.address')}
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        {t('contact.phoneNumber')}
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        {t('contact.emailAddress')}
      </li>
    </ul>
  );
}
